import type { ColorValue, StyleProp, ViewStyle } from 'react-native';
import { View } from 'react-native';
import { Text } from 'app/design/primitives/text';
import { useTheme } from 'app/shopify';

export function Separator({
  height = 1,
  color,
  style,
  onlyWidth = false,
}: {
  height?: number;
  color?: ColorValue;
  style?: StyleProp<ViewStyle>;
  onlyWidth?: boolean;
}) {
  const theme = useTheme();
  return (
    <View
      style={[
        {
          height,
          maxHeight: height,
          backgroundColor: color ?? theme.colors['surface.inverse.tertiary-neutral'],
        },
        onlyWidth ? { width: '100%' } : { flex: 1, width: '100%' },
        style,
      ]}
    />
  );
}

interface TextDividerProps {
  text: string;
  marginBottom?: number;
  height?: number;
}

export default function TextDivider({ text, marginBottom, height = 1 }: TextDividerProps) {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom }}>
      <Separator height={height} />
      <Text style={{ marginHorizontal: 16 }}>{text}</Text>
      <Separator height={height} />
    </View>
  );
}
